import { makeMainGEvent, pushEvent } from '../../../../utils/analytics';
import { Offer } from '../../Offer';
import styles from '../styles/StrahovanieNedvizhimosti.module.scss';

export const StrahovanieNedvizhimosti = () => {
  const handleClick = () => {
    pushEvent(
      makeMainGEvent({
        eventCategory: 'ИФЛ',
        eventAction: 'Сезонные предложения',
      }),
    );
  };

  return (
    <Offer
      title={'Защитите квартиру\nот залива, пожара и кражи'}
      subtitle="Компенсация до 580 000 ₽, если пострадает ремонт, техника&nbsp;или мебель"
      color="blue"
      href={'/strahovanie-nedvizhimosti/gift-policies/'}
      badgeText="скидка 20%"
      linkText="Защитить от 999 ₽"
      imageClassName={styles.picture}
      picture={[
        <source
          key="source-product-strahovanie-nedvizhimosti-png"
          srcSet={require('../images/img.png')}
          media={`(min-width: ${styles.breakpointDesktop})`}
          type="image/webp"
        />,
        <img key="img-product-strahovanie-nedvizhimosti" src={require('../images/img_mob.png')} alt="" />,
      ]}
      onClick={handleClick}
    />
  );
};
